var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgNg = function SvgNg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h639.98v479.998H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36a100",
    d: "M426.654 0H639.98v479.998H426.654zM0 0h213.327v479.998H0z"
  }))));
};
export default __webpack_public_path__ + "assets/cc34b827e201b3f7949fea06edf94d4a.svg";
export { SvgNg as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/ng.svg